<template>
  <div class="animated fadeIn">
    <b-card>
      <template v-if="details.length > 0">
        <h1>{{label}} </h1>
        <template v-if="users.length > 0">
          <div>Helpdesk :
            <template v-for="user in users">
              <span class="badge badge-info">
                {{user.name}}
              </span> &nbsp
            </template>
          </div>
        </template>

        <!--<table class="table table-responsive" v-if="details.length > 0">
          <thead>
          <tr >
            <th>No</th>
            <th v-for="(detail, key) in details[0]">{{key}}</th>
          </tr>
          </thead>
            <tbody>
              <tr v-for="(detail, i) in details">
                <td>{{i + 1}}</td>
                <template v-for="(value, index) in detail">
                  <td>{{value}}</td>
                </template>
              </tr>
            </tbody>
        </table>-->
        <template v-if="mode==1">
          <div class="table-responsive">
            <table class="table table-bordered table-striped tbl-border">
              <thead>
              <tr>
                <th>No</th>
                <th>User Id</th>
                <th>Name</th>
                <th style="min-width: 90px;">Ticket Id</th>
                <th style="min-width: 110px;">Create</th>
                <th style="min-width: 110px;">Solved</th>
                <th style="min-width: 450px;">Problem</th>
                <th style="min-width: 200px;">RFO</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail, i) in details">
                <td>{{i + 1}}</td>
                <td>{{detail.user_id}}</td>
                <td>{{detail.name}}</td>
                <td>
                  <a :href="'https://isx.nusa.net.id/xtts.php?pid=detail&id=' + detail.TtsId ">{{detail.TtsId}}</a>
                </td>
                <td>{{detail.date_created | moment}}</td>
                <td>{{detail.date_solved | moment}}</td>
                <td>{{detail.problem}}</td>
                <td>{{detail.rfo}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="mode==2">
          <div class="table-responsive">
            <table class="table table-bordered table-striped tbl-border">
              <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                <th style="min-width: 110px;">Date</th>
                <th>Src</th>
                <th>Duration</th>
                <th>Status</th>
                <th style="min-width: 400px">Recording</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail, i) in details">
                <td>{{i + 1}}</td>
                <td>{{detail.name}}</td>
                <td>{{detail.calldate}}</td>
                <td>{{detail.src}}</td>
                <td>{{detail.durationcall | seconds}}</td>
                <td>{{detail.disposition}}</td>
                <td>
                  <vue-audio :file="detail.recordingfile_link" :loop="true"/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="mode==3">
          <div class="table-responsive">
            <table class="table table-bordered table-striped tbl-border">
              <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                <th style="min-width: 90px;">Ticket Id</th>
                <th>Create</th>
                <th style="min-width: 400px">Problem</th>
                <th>RFO</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail, i) in details">
                <td>{{i + 1}}</td>
                <td>{{detail.name}}</td>
                <td>
                  <a :href="'https://isx.nusa.net.id/xtts.php?pid=detail&id=' + detail.TtsId ">{{detail.TtsId}}</a>
                </td>
                <td style="min-width: 106px;">{{detail.create_date | moments}}</td>
                <td>{{detail.Problem}}</td>
                <td>{{detail.Rfo}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="mode==4">
          <div class="table-responsive">
            <table class="table table-bordered table-striped tbl-border">
              <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                <th style="min-width: 110px;">DND Start</th>
                <th style="min-width: 110px;">DND End</th>
                <th>Duration</th>
                <th>Extension</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail, i) in details">
                <td>{{i + 1}}</td>
                <td>{{detail.name}}</td>
                <td>{{detail.dndstart | momentsWithSec}}</td>
                <td>{{detail.dndend | momentsWithSec}}</td>
                <td>{{detail.duration | seconds}}</td>
                <td>{{detail.extension}}</td>
              </tr>
              <template v-if="$route.query.key == 29">
                <tr>
                  <td colspan="4" align="center"><strong>
                    Total
                  </strong></td>
                  <td colspan="2">
                   {{totalDND | seconds}}
                  </td>
                </tr>
              </template>
              <template v-else-if="$route.query.key == 10">
                <tr>
                  <td colspan="4" align="center"><strong>
                    Average
                  </strong></td>
                  <td colspan="2">
                   {{(totalDND / details.length ) | seconds}}
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="mode==5">
          <template v-if="details.length > 0">
            <div class="table-responsive">
              <table class="table table-bordered table-striped tbl-border">
                <thead>
                <tr>
                  <th>No</th>
                  <th>Name</th>
                  <th style="min-width: 108px">Created</th>
                  <template v-if="details[0].total_ticket">
                    <th style="text-align: center">Total Ticket</th>
                    <th style="text-align: center">Score</th>
                  </template>
                  <template v-else-if="details[0].Problem">
                    <th style="min-width: 400px">Problem</th>
                    <th>RFO</th>
                    <th>Score</th>
                  </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(detail, i) in details">
                  <td>{{i + 1}}</td>
                  <td>{{detail.name}}</td>
                  <td>{{detail.date_report | moment}}</td>
                  <template v-if="detail.total_ticket">
                    <td align="center">
                      <a :href="detail | hrefRincianSatisfaction(users)">
                        {{detail.total_ticket}}
                      </a>
                    </td>
                    <td align="center">{{detail.total_score}}</td>
                  </template>
                  <template v-else-if="detail.Problem">
                    <td>
                      <a :href="'https://isx.nusa.net.id/xtts.php?pid=detail&id=' + detail.ticket_id ">
                        {{detail.Problem}}
                      </a></td>
                    <td>{{detail.Rfo}}</td>
                    <td align="center">{{detail.score}}</td>
                  </template>
                </tr>
                <template v-if="details[0].total_ticket">
                  <tr>
                    <td colspan="3" align="center" style="font-weight: bold">Total</td>
                    <td align="center" style="font-weight: bold">{{details | totalSatisfaction(1)}}</td>
                    <td align="center" style="font-weight: bold">{{details | totalSatisfaction(3)}}</td>
                  </tr>
                  <tr>
                    <td colspan="4" align="center" style="font-weight: bold">Average</td>
                    <td align="center" style="font-weight: bold">{{details | totalSatisfaction(5)}}</td>
                  </tr>
                </template>
                <template v-if="details[0].Problem">
                  <tr>
                    <td colspan="5" align="center" style="font-weight: bold">Total</td>
                    <td align="center" style="font-weight: bold">{{details | totalSatisfaction(2)}}</td>
                  </tr>
                  <tr>
                    <td colspan="5" align="center" style="font-weight: bold">Average</td>
                    <td align="center" style="font-weight: bold"> {{details | totalSatisfaction(4)}}</td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </template>
        </template>
        <template v-if="mode==6">
          <h5>Date Report: {{data.date_report}}</h5>
          <h5>Total Email: {{data.total_email}}</h5>
          <h5>Total Diff Reply: {{data.total_diff_reply | seconds}}</h5>
          <h5>Avg Reply: {{data.avg_reply | seconds}}</h5>
          <br>
          <h5>Email Detail</h5>
            <b-tabs>
              <b-tab title="List" active>
                <div class="table-responsive">
                <table class="table table-bordered table-striped tbl-border">
              <thead>
              <tr>
                <th>No</th>
                <th>From</th>
                <th>To</th>
                <th>Subject</th>
                <th>Status</th>
                <th>Date</th>
                <th>Time Received</th>
                <th>Time Respon</th>
                <th>Time Diff</th>
               <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail, i) in details"
                  v-bind:class="detail.similar_from_to ? 'same' : ''"
                  :key="detail.id"
              >
                <td>{{i + 1}}</td>
                <td>{{detail.name}}
                </td>
                <td>{{detail.admin_name}}
                </td>
                <td>{{detail.subject}}</td>
                <td>{{detail.status}}</td>
                <td>{{detail.date | moment}}</td>
                <td>{{detail.time_received}}</td>
                <td>{{detail.time_respond}}</td>
                <td>{{detail.time_diff | seconds}}</td>
                <td>
                  <i class="fa fa-eye pointer text-info"
                  @click="detailReply(detail.note)"
                  v-b-tooltip.hover title="Log"
                  >
                  </i>
                  &nbsp;
                  <i class="fa fa-trash pointer"
                   @click="goToModalEdit (detail.id, 'delete', 'Delete', i)"
                   v-b-tooltip.hover title="Delete"
                   ></i> &nbsp;
                   <!-- <i 
                  v-if="detail.similar_from_to"
                   class="fa fa-check-square-o text-info pointer"
                   @click="goToModalEdit (detail.id, 'ignore', 'Ignore', i)"
                   v-b-tooltip.hover title="Ignore"
                   ></i> &nbsp; -->

                </td>
              </tr>
              </tbody>
            </table>
            </div>
              </b-tab>
              
              <b-tab title="Delete">
                <table class="table table-bordered table-striped tbl-border">
              <thead>
              <tr>
                <th>No</th>
                <th>From</th>
                <th>To</th>
                <th>Subject</th>
                <th>Status</th>
                <th>Date</th>
                <th>Time Received</th>
                <th>Time Respon</th>
                <th>Time Diff</th>
               <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail, i) in listDeleteWebmail"
                  v-bind:class="detail.similar_from_to ? 'same' : ''"
                  :key="detail.id"
              >
                <td>{{i + 1}}</td>
                <td>{{detail.name}}
                </td>
                <td>{{detail.admin_name}}
                </td>
                <td>{{detail.subject}}</td>
                <td>{{detail.status}}</td>
                <td>{{detail.date | moment}}</td>
                <td>{{detail.time_received}}</td>
                <td>{{detail.time_respond}}</td>
                <td>{{detail.time_diff | seconds}}</td>
                <td>
                  <i class="fa fa-reply pointer"
                    @click="goToModalEdit (detail.id, 'restore', 'Restore', i)"
                  ></i>
                  <!-- <i class="fa fa-eye pointer text-info"
                  @click="detailReply(detail.note)"
                  v-b-tooltip.hover title="Log"
                  >
                  </i>
                  &nbsp;
                  <i class="fa fa-trash pointer"
                   @click="goToModalEdit (detail.id, 'delete', 'Delete', i)"
                   v-b-tooltip.hover title="Delete"
                   ></i> &nbsp; -->
                   <!-- <i 
                  v-if="detail.similar_from_to"
                   class="fa fa-check-square-o text-info pointer"
                   @click="goToModalEdit (detail.id, 'ignore', 'Ignore', i)"
                   v-b-tooltip.hover title="Ignore"
                   ></i> &nbsp; -->
                </td>
              </tr>
              <tr v-if="listDeleteWebmail.length == 0" class="bg-warning">
                <td colspan="10">No Data Delete</td>
              </tr>
              </tbody>
            </table>
              </b-tab>
            </b-tabs>
        </template>
        <template v-if="mode==7">
          <h5>Date Report: {{data.date_report}}</h5>
          <h5>Total SMS: {{data.total_sms}}</h5>
          <h5>Total Diff Reply: {{data.total_diff_reply | seconds}}</h5>
          <h5>Avg Reply: {{data.avg_reply | seconds}}</h5>
          <br>
          <h5>SMS Detail</h5>
          <div class="table-responsive">
            <table class="table table-bordered table-striped tbl-border">
              <thead>
              <tr>
                <th>No</th>
                <th>Inbox</th>
                <th> Reply</th>
                <th style="min-width: 100px">Diff</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail, i) in details">
                <td>{{i + 1}}</td>
                <td>{{detail.msg_inbox}} <br>
                  ( {{detail.time_inbox | momentsWithSec}} ) <br>
                  <strong>Sender</strong> : {{detail.sender}}
                </td>
                <td>{{detail.msg_reply}} <br>
                  ( {{detail.time_reply | momentsWithSec}} ) <br>
                  <strong>Reply</strong> : {{detail.reply_by}}
                </td>
                <td>{{detail.time_diff | seconds}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="mode==8">
          <div class="table-responsive">
            <table class="table table-bordered table-striped tbl-border">
              <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                <th style="min-width: 90px">Ticket Id</th>
                <th style="min-width: 108px">Created</th>
                <th style="min-width: 400px">Problem</th>
                <th style="min-width: 200px">RFO</th>
                <th style="min-width: 108px">Reopen</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail, i) in details">
                <td>{{i + 1}}</td>
                <td>{{detail.name}}</td>
                <td>
                  <a :href="'https://isx.nusa.net.id/xtts.php?pid=detail&id=' + detail.TtsId ">{{detail.TtsId}}</a>
                </td>
                <td>{{detail.ticket_created | momentsWithSec}}</td>
                <td>{{detail.Problem}}</td>
                <td>{{detail.Rfo}}</td>
                <td>{{detail.reopen_date | momentsWithSec}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="mode==9">
          <div class="table-responsive">
            <table class="table table-bordered table-striped tbl-border">
              <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                <th style="min-width: 90px;">Ticket Id</th>
                <th style="min-width: 108px;">Date</th>
                <th style="min-width: 400px;">Problem</th>
                <th style="min-width: 200px;">RFO</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail, i) in details">
                <td>{{i + 1}}</td>
                <td>{{detail.name}}</td>
                <td>
                  <a :href="'https://isx.nusa.net.id/xtts.php?pid=detail&id=' + detail.TtsId ">{{detail.TtsId}}</a>
                </td>
                <td style="min-width: 106px;">{{detail.date_report}}</td>
                <td>{{detail.problem}}</td>
                <td>{{detail.rfo}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="mode == 10">
          <div class="table-responsive">
            <table class="table table-striped table-bordered tbl-border">
              <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                <th style="min-width: 108px">Date</th>
                <th>Description</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail, i) in details">
                <td>{{i + 1}}</td>
                <td>{{detail.name}}</td>
                <td>{{detail.date}}</td>
                <td>{{detail.description}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
      </template>
      <template v-else-if="error">
        <div class="alert alert-warning">
          {{textError}}
        </div>
      </template>
      <template v-else>
        <h3>No Data</h3>
      </template>
    </b-card>
    <b-modal title="Log Detail Edit Reply Email" class="modal-info" v-model="logReply" @ok="logReply == false" >
      <template v-if="listlogReply.length">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>No</th>
            <th>Update By</th>
            <th>Date</th>
            <th>Operation</th>
            <th>Note</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(item, i) in listlogReply">
            <tr>
              <td>{{i + 1}}</td>
              <td>{{item.updateByName}}</td>
              <td>{{item.date}}</td>
              <td>{{item.operation}}</td>
              <td>{{item.reason}}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </template>
      <template v-else>
        No Log
      </template>
    </b-modal>
    <b-modal 
    :title="postWebmail.title"
    class="modal-info"
    v-model="postModal"
    @ok="postWebmailAction()"
    :ok-disabled="note.length < 5"
    >
      <template>
        <b-form-textarea
      id="textarea"
      v-model="note"
      placeholder="Note minimal 5 character"
      rows="3"
      max-rows="6"
    ></b-form-textarea>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {getService} from '@/services'
  import {postService} from '@/services'
  import moment from 'moment'
  import VueAudio from 'vue-audio';
  import axios from 'axios';

  export default {
    name: 'DetailKpi',
    components: {
      'vue-audio': VueAudio,
    },
    data() {
      return {
        textError: '',
        error: false,
        details: [],
        data: [],
        label: '',
        users: [],
        mode: '',
        page: '',
        totalDND: 0,
        listlogReply: [],
        listDeleteWebmail: [],
        logReply: false,
        postModal: false,
        note: '',
        postWebmail: {
          id: '',
          title: '',
          action: '',
          index: 0,
        }
      }
    },
    created: function () {
      var params = this.$route.query.key
      if (params == 1) {
        this.mode = 1
      } else if (params == 2 ||
        params == 7 ||
        params == 8 ||
        params == 9 ||
        params == 20) {
        this.mode = 2
      } else if (params == 3 ||
        params == 4 ||
        params == 5 ||
        params == 6) {
        this.mode = 3
      } else if (params == 10 || params == 29) {
        this.mode = 4
      } else if (params == 12) {
        this.mode = 5
      } else if (params == 14) {
        this.mode = 6
      } else if (params == 13) {
        this.mode = 7
      } else if (params == 19) {
        this.mode = 8
      } else if (params == 21 ||
        params == 22 ||
        params == 23 ||
        params == 24 ||
        params == 25 ||
        params == 26 ||
        params == 28
      ) {
        this.mode = 9
      } else if (params == 16 ||
        params == 17 ||
        params == 18) {
        this.mode = 10
      }
      if (this.$route.query.type == 2) {
        // from metric
        this.getDetailFromMetric(this.$route.query.create, this.$route.query.key)
      } else if (this.mode == 6) {
        let that = this
        axios.all([getService.list_helpdesk_detail(this.$route.query.pic, this.$route.query.create, this.$route.query.key, this.$route.query.type), getService.list_delete_webmail(this.$route.query.create ,this.$route.query.pic)])
          .then(axios.spread(function (acct, perms) {
            that.actionData(acct)
            that.actionListDelete(perms)
            // that.getChartList(perms)
          })).catch(function (error) {
            // error
            console.error(error)
          })
      } else {
        this.getDetailKPI(this.$route.query.pic, this.$route.query.create, this.$route.query.key, this.$route.query.type)
      }
    },
    methods: {
      getDetailKPI: function (user, date, label, month) {
        this.$store.commit('noLoad', true)
        getService.list_helpdesk_detail(user, date, label, month)
          .then(data => {
            this.actionData(data)
          })
          .catch(error => {
            const data = error;
            if (data.status != 200) {
              this.error = true
              this.textError = data.statusText
            }
            this.$store.commit('noLoad', false)
          })
      },
      getDetailFromMetric: function(create, key) {
        this.$store.commit('noLoad', true)
        getService.list_detail_from_metric(create, key)
          .then(data => {
            this.actionData(data)
          })
          .catch(error => {
            const data = error;
            if (data.status != 200) {
              this.error = true
              this.textError = data.statusText
            }
            this.$store.commit('noLoad', false)
          })
      },
      actionListDelete(data) {
        this.listDeleteWebmail = data.data.email_detail ? data.data.email_detail : []
        
      },
      actionData(data) {
        this.$store.commit('noLoad', false)
        this.label = data.label
        this.users = data.user
        if (this.mode == 2 || this.mode == 4) {
          var result = []
          for (var i in this.users) {
            result.push(this.users[i]);
          }
          this.users = result
        }
        if (this.mode == 7) {
          this.details = data.data.sms_detail
          this.data = data.data
        } else if (this.mode == 6) {
          this.details = data.data.email_detail
          this.data = data.data
        } else {
          this.details = data.data
          if (this.mode == 4) {
            for (let j in this.details) {
              if (this.details.hasOwnProperty(j)) {
                this.totalDND += this.details[j].duration
              }
            }
          }
          if (data.page_info.next_page != data.page_info.prev_page) {
            if (this.page !== data.page_info.next_page) {
              this.page = data.page_info.next_page
              this.getPage(data.page_info.next_page)
            }
          }
        }
      },
      getPage(links) {
        getService.list_helpdeks_detail_page(links)
          .then(data => {
            var i
            for (i = 0; i < data.data.length; i++) {
              this.details.push(data.data[i])
              if (this.mode == 4) {
                this.totalDND += data.data[i].duration
              }
            }
            if (data.page_info.next_page != data.page_info.prev_page) {
              if (this.page !== data.page_info.next_page) {
                this.page = data.page_info.next_page
                this.getPage(data.page_info.next_page)
              }
            }
          })
      },
      detailReply(data) {
          this.listlogReply = []
          this.logReply = true
          this.listlogReply = data
      },
      goToModalEdit (id, action, title, index) {
        this.postModal = true
        this.postWebmail.id = id
        this.postWebmail.title = title
        this.postWebmail.action = action
        this.postWebmail.index = index
        this.note = ''
      }, 
      postWebmailAction(bvModalEvt) {
        // if (this.note.length >= 5) {
          postService.postActionWebmail(this.postWebmail.action, this.postWebmail.id, this.note)
          .then(data => {
            const item = {
              id: data.data.id,
              name: data.data.name,
              subject: data.data.subject,
              status: data.status,
              date: data.data.created_at,
              time_received: data.data.time_received,
              time_respond: data.data.time_respond,
              time_diff: data.data.time_diff,
            }
            if (data.title == 'remove success') {
               this.details.splice(this.postWebmail.index, 1)
                this.listDeleteWebmail.push(item)
            } else {
               this.listDeleteWebmail.splice(this.postWebmail.index, 1)
              this.details.push(item)
            }
            // this.details[this.postWebmail.index].similar_from_to = true
            this.postModal == false
          })
        // }
      }
    },
    filters: {
      moment: function (date) {
        return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
      },
      moments: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')
      },
      momentsWithSec: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')
      },
      seconds: function (time) {
        var d = Number(time)
        var h = Math.floor(d / 3600)
        var m = Math.floor(d % 3600 / 60)
        var s = Math.floor(d % 3600 % 60)

        var hDisplay = h > 9 ? h + "h " : h > 0 ? '0' + h + 'h ' : ""
        var mDisplay = m > 9 ? m + "m " : m >= 0 ? '0' + m + "m " : ""
        var sDisplay = s <= 9 ? '0' + s + 's' : s + 's'
        return hDisplay + mDisplay + sDisplay
      },
      totalSatisfaction(item, type) {
        // type 1 => total ticket bulan
        // type 2 => total score tanggal
        // type 3 => total score bulan
        // type 4 => average tanggal
        // type 5 => average bulan
        var total = 0, average = 0, score = 0
        if (item.length > 0) {
          for (var i = 0; i < item.length; i++) {
            if (type == 1 || type == 5) {
              total = total + item[i].total_ticket
            } else if (type == 2 || type == 4) {
              score = score + item[i].score
            } else if (type == 3) {
              score = score + Number(item[i].total_score)
            }
            if (type == 5) {
              score = score + Number(item[i].total_score)
            }
          }
          if (type == 4) {
            average = score / i
            return average
          } else if (type == 2 || type == 3) {
            return score
          } else if (type == 5) {
            average = score / total
            return average.toFixed(2)
          }
          return total
        }
        return 0
      },
      hrefRincianSatisfaction(item, user) {
        var create = item.date_report
        var users = ''
        for (var i = 0; i < user.length; i++) {
          if (user.length <= 1) {
            users = user[i].user_id
          } else {
            users = user + ',' + user[i].user_id
          }
        }
        return '#/kpi/helpdesk/detail?create=' + create +
          '&pic=' + users +
          '&key=12&month=0&mode=12'
      }
    }
  };
</script>

<style>
  .tbl-border {
    border: solid 2.5px #000 !important;
    margin-top: 20px;
  }

  .pointer{
    cursor: pointer;
  }

  .pointer:hover{
    background-color: #DDDDDD !important;
  }

  .same{
    background-color: #ffcdd2 !important;
  }



</style>
